export default {
  // ページタイトルとアクション
  backToDashboard: 'ダッシュボードに戻る',
  shareCareInstructions: 'ケア指示を共有',
  edit: '編集',
  preview: 'プレビュー',
  
  // 空の状態
  petNotFound: 'ペットが見つかりません',
  petNotFoundDesc: 'このペットは削除されたか、存在しません',
  
  // 基本情報
  basicInfo: '基本情報',
  unnamedPet: '名前のないペット',
  notSpecified: '未指定',
  unknown: '不明',
  notSet: '未設定',
  
  // 種類と性別
  type: '種類',
  breed: '品種',
  age: '年齢',
  birthDate: '生年月日',
  gender: '性別',
  male: 'オス',
  female: 'メス',
  weight: '体重',
  height: '身長',
  color: '色',
  coatType: '被毛タイプ',
  eyeColor: '目の色',
  bodySize: '体の大きさ',
  specialMarkings: '特別なマーキング',
  microchipId: 'マイクロチップID',
  registrationId: '登録ID',
  currentLocation: '現在地',
  
  // 時間単位
  year: '年',
  years: '年',
  month: 'ヶ月',
  months: 'ヶ月',
  
  // セクションタイトル
  physicalTraits: '外見の特徴',
  dietaryInfo: '食事情報',
  behaviorInfo: '行動情報',
  healthInfo: '健康情報',
  veterinarianInfo: '獣医情報',
  specialNotes: '特記事項',
  
  // 食事関連
  feedingSchedule: '給餌スケジュール',
  nextFeeding: '次の給餌',
  canEat: '食べられる',
  cannotEat: '食べられない',
  breakfast: '朝食',
  lunch: '昼食',
  dinner: '夕食',
  snack: 'おやつ',
  portionSize: '分量',
  foodType: '食べ物の種類',
  time: '時間',
  
  // 行動関連
  temperament: '気質',
  likes: '好き',
  dislikes: '嫌い',
  exerciseNeeds: '運動ニーズ',
  trainingNotes: 'トレーニングノート',
  
  // 健康関連
  medicationSchedule: '投薬スケジュール',
  nextMedication: '次の投薬',
  medications: '薬',
  medicationName: '薬名',
  dosage: '用量',
  frequency: '頻度',
  daily: '毎日',
  twiceDaily: '1日2回',
  thriceDaily: '1日3回',
  weekly: '毎週',
  monthly: '毎月',
  custom: 'カスタム',
  morningMeds: '朝の薬',
  afternoonMeds: '午後の薬',
  eveningMeds: '夕方の薬',
  nightMeds: '夜の薬',
  vaccines: 'ワクチン',
  nextVaccineDate: '次のワクチン接種日',
  nextVetVisit: '次の獣医訪問',
  allergies: 'アレルギー',
  medicalConditions: '医療状態',
  
  // 獣医情報
  vetName: '獣医クリニック',
  vetPhone: '獣医電話',
  vetAddress: '獣医住所',
  vetEmail: '獣医メール',
  insuranceProvider: '保険会社',
  insurancePolicy: '保険証券番号',
  
  // ロード状態
  loadingPet: 'ペットデータを読み込み中...',
  
  // 未記入状態
  notFilled: '未記入',
  home: '自宅',
};